<template>
  <div class="relative">
    <span class="absolute copy-text bg-green-600 text-white font-bold px-2" v-show="isCopied">Copied!</span>
    <svg v-if="isCopied" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
      class="w-4 h-4 cursor-pointer text-wizpay-red">
      <title>Copied</title>
      <path fill-rule="evenodd"
        d="M17.663 3.118c.225.015.45.032.673.05C19.876 3.298 21 4.604 21 6.109v9.642a3 3 0 01-3 3V16.5c0-5.922-4.576-10.775-10.384-11.217.324-1.132 1.3-2.01 2.548-2.114.224-.019.448-.036.673-.051A3 3 0 0113.5 1.5H15a3 3 0 012.663 1.618zM12 4.5A1.5 1.5 0 0113.5 3H15a1.5 1.5 0 011.5 1.5H12z"
        clip-rule="evenodd" />
      <path
        d="M3 8.625c0-1.036.84-1.875 1.875-1.875h.375A3.75 3.75 0 019 10.5v1.875c0 1.036.84 1.875 1.875 1.875h1.875A3.75 3.75 0 0116.5 18v2.625c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 013 20.625v-12z" />
      <path
        d="M10.5 10.5a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963 5.23 5.23 0 00-3.434-1.279h-1.875a.375.375 0 01-.375-.375V10.5z" />
    </svg>
    <svg v-else @click.stop="copyToClipBoard" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
      stroke-width="1.5" stroke="currentColor" class="w-4 h-4 cursor-pointer text-wizpay-red">
      <title>Copy to clipboard</title>
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z" />
    </svg>
  </div>
</template>

<script>
export default {
  name: "rsd-copy-to-clipboard",
  props: ["textToCopy"],
  data() {
    return {
      isCopied: false,
    };
  },
  watch: {
    isCopied(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.isCopied = false;
        }, 200)
      }
    },
  },
  methods: {
    copyToClipBoard() {
      navigator.clipboard.writeText(this.textToCopy);
      this.isCopied = true;
    },
  },
}
</script>

<style lang="scss" scoped>
.copy-text {
  top: -24px;
  left: -18px;
  font-size: 10px;
}
</style>